export const PATH = {
  PARTICIPANT: '/participant',
  PROFESSIONAL: '/professional',
};

export const PAGES = {
  LANDING: 'landing',
  PARTICIPANT: {
    HOME: 'participant-area-schedules',
    // LOGIN: 'landing-login',
    LOGIN: 'participant-area-login',
    LOGOUT: 'participant-area-logout',
    FORBIDDEN: 'participant-area-forbidden',
    FORGOT_PASSWORD: 'participant-area-forgot-password',
  },
  PROFESSIONAL: {
    HOME: 'professional-home',
    // LOGIN: 'professional-login',
    LOGIN: 'landing-login',
    LOGOUT: 'professional-logout',
    FORBIDDEN: 'professional-forbidden',
    FORGOT_PASSWORD: 'professional-forgot-password',
  },
};




// WEBPACK FOOTER //
// ./src/constants/url.js